import React from "react";
import { StoryItem } from "@swo/storefront";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { IntendedUseCard } from "../IntendedUseCard";
import { unlabeledInternalLinkOf } from "../../../domain/swarovski-optik/links";
import { FONTS, fontSize } from "../../../styles/fonts";
import { ContentfulImage2 } from "../../../components/_shared-components/image-related/ContentfulImage2";
import { EXPERIMENTAL_TextWithProductNameRenderer } from "../../../domain/swarovski-optik/products/product-name/product-name-renderer";
import { CSS_MQ } from "../../../styles/breakpoints";

export const IntendedUseStoryItemCard: React.FC<{
  card: StoryItem;
}> = ({ card: { emoHeadline, seoHeadline, link, image } }) => {
  const internalLink = unlabeledInternalLinkOf({
    pathname: link,
  });

  return (
    <IntendedUseCard
      link={internalLink}
      hasBorderRadius={false}
      attachStyles={css`
        text-decoration: none;
        color: ${CSS_COLORS.Black};
      `}
    >
      <div
        css={css`
          flex-grow: 1;

          display: flex;
          flex-direction: column;
          gap: 12px;

          ${CSS_MQ.atLeastMd} {
            display: grid;
            grid-template-rows: auto 1fr;
            grid-auto-flow: row;

            grid-gap: 12px;
          }

          position: relative;
        `}
      >
        <div
          css={css`
            aspect-ratio: 16/9;
            ${CSS_MQ.atLeastSm} {
              aspect-ratio: 3/2;
            }
            position: relative;
          `}
        >
          {image ? (
            <ContentfulImage2
              assetId={image.image.sys.id}
              contentfulUrl={image.image.url}
              cropping={image}
              alt={""}
              css={css`
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
                position: absolute;
              `}
              sizes="(max-width: 575px) 100vw, (max-width: 1399px) 400px, 450px"
              withTransparency={false}
            />
          ) : (
            <span>No image</span>
          )}
        </div>

        <div
          css={css`
            position: relative;

            display: flex;
            flex-direction: column;
            flex-grow: 1;
          `}
        >
          <div
            className="u-overflow-y-hidden"
            css={css`
              ${CSS_MQ.atLeastSm} {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
              }
            `}
          >
            <div
              className="u-uppercase"
              css={css`
                margin-bottom: 4px;
                ${CSS_MQ.atLeastSm} {
                  margin-bottom: 8px;
                }
              `}
            >
              <EXPERIMENTAL_TextWithProductNameRenderer text={seoHeadline} />
            </div>

            <span
              css={[
                FONTS.MinervaModern500,
                fontSize.x4,
                css`
                  display: -webkit-box;

                  -webkit-line-clamp: 3;
                  ${CSS_MQ.atLeastXl} {
                    -webkit-line-clamp: 4;
                  }

                  -webkit-box-orient: vertical;
                  overflow: hidden;

                  line-height: 1.05;
                `,
              ]}
              className="u-uppercase so-color-green"
            >
              {emoHeadline}
            </span>
          </div>
        </div>
      </div>
    </IntendedUseCard>
  );
};
